import { render } from "./two-form.vue?vue&type=template&id=99ce1c78&scoped=true"
import script from "./two-form.vue?vue&type=script&lang=js"
export * from "./two-form.vue?vue&type=script&lang=js"

import "./two-form.vue?vue&type=style&index=0&id=99ce1c78&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99ce1c78"]])

export default __exports__